import { render, staticRenderFns } from "./LessonDripMode.vue?vue&type=template&id=488febfa&"
import script from "./LessonDripMode.vue?vue&type=script&lang=js&"
export * from "./LessonDripMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports